import Umami from 'umami-track';

const umami = new Umami({
    src: '//umami.yoyi.com.cn/script.js',
    websiteId: 'c1d53f3b-44df-46ed-b1c0-175a94d93581',
    domains: ['dna.yoyi.com.cn'],
    performance: true
});

export default umami;